import TypingDots from "@/components/TypingDots";

export default function MessageBubble({ role, content, thinking = false, author }) {
    const isUser = role === "user";

    if (isUser) {
        return (
            <div className="flex flex-col items-end" data-testid="bubble-user">
                {author && (
                    <span className="mb-1 text-[11px] text-[#737373]" data-testid="bubble-author">
                        {author}
                    </span>
                )}
                <div className="max-w-[80%] rounded-2xl rounded-br-md bg-[#0A0A0A] px-4 py-2.5 text-[15px] leading-relaxed text-white">
                    {content}
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-start gap-3" data-testid="bubble-assistant">
            <div
                aria-hidden
                className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-[#E5E5E5] bg-white text-[11px] font-semibold tracking-tight text-[#0A0A0A]"
            >
                T
            </div>
            <div className="flex-1 pt-1 text-[15px] leading-relaxed text-[#0A0A0A]">
                {thinking ? <TypingDots /> : content}
            </div>
        </div>
    );
}
